import dayjs from 'dayjs'
import { addParams } from '@/utils/getUrlParam'

export * from './glms'
// 手机号过滤器   把手机号转化为中间4位为*的加密数据
export function phoneFilter(val) {
  if (isNaN(Number(val))) return val
  val = val + ''
  const reg = /^(.{3}).*(.{4})$/
  return val.replace(reg, '$1****$2')
}

export function getFormatTime(item) {
  return dayjs(item.create_time).format('YYYY-MM-DD HH:mm:ss')
}

export function convertNumberToDisplayFilter(n) {
  if (!n) {
    return '0'
  }
  if (n >= 0 && n < 10000) {
    return String(n)
  } else if (n >= 10000 && n < 100000) {
    const num = Math.round(n / 100) / 100
    const resultStr = String(num)
    return resultStr + 'w'
  } else if (n >= 100000 && n < 1000000) {
    const num = Math.round(n / 1000) / 10
    return num.toString() + 'w'
  } else if (n >= 1000000) {
    const result = Math.round(n / 10000)
    return String(result) + 'w'
  }
}

export function imageConver(val) {
  return addParams(val, 'image_process=format,webp')
}

export function scopeFilter(val) {
  if (val === 4) {
    return '公开'
  } else if (val === 2) {
    return '可分享'
  } else {
    return '私密'
  }
}
